export class ContentRendererCanvas {
    
    static setUpCanvases(prodImg, maskImg) {
        const canvasWidth = prodImg.width;
        const canvasHeight = prodImg.height;
    
        const createCanvas = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = canvasWidth;
            canvas.height = canvasHeight;
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";
            return { canvas, ctx };
        };
    
        // Only create content canvases - compositing canvases have been removed
        const { canvas: backgroundCanvas, ctx: backgroundCtx } = createCanvas();
        const { canvas: stickersCanvas, ctx: stickersCtx } = createCanvas();
        const { canvas: photoStickersCanvas, ctx: photoStickersCtx } = createCanvas();
        const { canvas: userImageCanvas, ctx: userImageCtx } = createCanvas();
        const { canvas: productCanvas, ctx: productCtx } = createCanvas();
        const { canvas: maskCanvas, ctx: maskCtx } = createCanvas();
        const { canvas: debugOverlayCanvas, ctx: debugOverlayCtx } = createCanvas();
        
        // Draw product images into their respective canvases
        productCtx.drawImage(prodImg, 0, 0, canvasWidth, canvasHeight);
        maskCtx.drawImage(maskImg, 0, 0, canvasWidth, canvasHeight);

        return {
            canvasWidth,
            canvasHeight,
            backgroundCanvas,
            backgroundCtx,
            stickersCanvas,
            stickersCtx,
            photoStickersCanvas,
            photoStickersCtx,
            userImageCanvas,
            userImageCtx,
            productCanvas,
            productCtx,
            maskCanvas,
            maskCtx,
            debugOverlayCanvas,
            debugOverlayCtx
        };
    }
    
    static makeFinalLayerTree(canvases, cyoDesign) {
        const layerTree = {
            bgImage: canvases.backgroundCanvas,
            userImage: canvases.userImageCanvas,
            stickers: canvases.stickersCanvas,
            photoStickers: canvases.photoStickersCanvas,
            product: canvases.productCanvas,
            mask: canvases.maskCanvas
        };
        
        // Add debug overlay layer if either safe area or bleed insets is enabled
        if (cyoDesign.debugOptions.showSafeArea || cyoDesign.debugOptions.showBleedInsets) {
            layerTree.debugOverlay = canvases.debugOverlayCanvas;
        }
        
        return layerTree;
    }

    static drawSafeAreaDebug(ctx, canvasWidth, canvasHeight, safeAreaInsets) {
        if (!safeAreaInsets || safeAreaInsets.length !== 4) {
            return;
        }
        
        // Convert ratios to pixel values: [top, right, bottom, left]
        const topMargin = safeAreaInsets[0] * canvasHeight;
        const rightMargin = safeAreaInsets[1] * canvasWidth;
        const bottomMargin = safeAreaInsets[2] * canvasHeight;
        const leftMargin = safeAreaInsets[3] * canvasWidth;
                
        // Set transparent green fill
        ctx.fillStyle = "rgba(0, 255, 0, 0.5)";
        
        // Draw the four margin rectangles (unsafe areas)
        if (topMargin > 0) {
            ctx.fillRect(0, 0, canvasWidth, topMargin);
        }
        
        if (rightMargin > 0) {
            ctx.fillRect(canvasWidth - rightMargin, topMargin, rightMargin, canvasHeight - topMargin - bottomMargin);
        }
        
        if (bottomMargin > 0) {
            ctx.fillRect(0, canvasHeight - bottomMargin, canvasWidth, bottomMargin);
        }
        
        if (leftMargin > 0) {
            ctx.fillRect(0, topMargin, leftMargin, canvasHeight - topMargin - bottomMargin);
        }
    }

    static drawBleedInsetsDebug(ctx, canvasWidth, canvasHeight, bleedInsets) {
        if (!bleedInsets || bleedInsets.length !== 4) {
            return;
        }
        
        // Convert ratios to pixel values: [top, right, bottom, left]
        const topMargin = bleedInsets[0] * canvasHeight;
        const rightMargin = bleedInsets[1] * canvasWidth;
        const bottomMargin = bleedInsets[2] * canvasHeight;
        const leftMargin = bleedInsets[3] * canvasWidth;
                
        // Set transparent red fill
        ctx.fillStyle = "rgba(255, 0, 0, 0.5)";
        
        // Draw the four margin rectangles (bleed areas)
        if (topMargin > 0) {
            ctx.fillRect(0, 0, canvasWidth, topMargin);
        }
        
        if (rightMargin > 0) {
            ctx.fillRect(canvasWidth - rightMargin, topMargin, rightMargin, canvasHeight - topMargin - bottomMargin);
        }
        
        if (bottomMargin > 0) {
            ctx.fillRect(0, canvasHeight - bottomMargin, canvasWidth, bottomMargin);
        }
        
        if (leftMargin > 0) {
            ctx.fillRect(0, topMargin, leftMargin, canvasHeight - topMargin - bottomMargin);
        }
    }
}